// extracted by mini-css-extract-plugin
module.exports = {"wrapper-long":"CourseSuggestion_wrapper-long__iot8s","form-wrapper":"CourseSuggestion_form-wrapper__AsnsN"};